export default {
  previews: state => state.previews,
  links: state => {
    const host = window.location.hostname
    const protocol = window.location.protocol
    return state.ids.map(id => {
      return `${protocol}//${host}/preview/${id}`
    })
  }
}
